import { Box } from "@mantine/core";
import { Outlet } from "react-router-dom";
import Footer from "../../components/Footer";
import TopNavbarHome from "../../components/NavigationBar/TopNavbarHome";

const LandingLayout = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      <TopNavbarHome />
      <Outlet />
      <Footer />
    </Box>
  );
};
export default LandingLayout;
